
import DailyReportSection from "@/components/marketAnalysis/DailyReportSection";
import MarketDataSection from "@/components/marketAnalysis/MarketDataSection";
import PersonalizedSection from "@/components/marketAnalysis/PersonalizedSection";
import SectorReportsSection from "@/components/marketAnalysis/SectorReportsSection";
import DailyReportTabIcon from "@/components/marketAnalysis/icons/DailyReportTabIcon";
import MarketDataTabIcon from "@/components/marketAnalysis/icons/MarketDataTabIcon";
import PersonalizedTabIcon from "@/components/marketAnalysis/icons/PersonalizedTabIcon";
import SectorReportTabIcon from "@/components/marketAnalysis/icons/SectorReportTabIcon";
import { sectorTabConstants, tabConstants } from '@/constants/marketAnalysis';
import subscriptionConstants from '@/constants/subscription.constants';
import { backendExceptionHandler } from "@/mixins";

const { subscribeProductKeys } = subscriptionConstants;

export default {
    name: 'MarketAnalysisPage',

    components: {
        DailyReportSection,
        PersonalizedSection,
        MarketDataSection,
        SectorReportsSection,
        DailyReportTabIcon,
        PersonalizedTabIcon,
        MarketDataTabIcon,
        SectorReportTabIcon,
    },

    mixins: [backendExceptionHandler],

    props: {
        pageKey: {
            type: String,
            default: '',
        },
        isArchiveMarketPage: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            activeTab: null,
            marketSummaryContent: null,
            marketSummaryCreatedAt: '',
            snippetDetailsTitle: false,
        }
    },

    head() {
        return {
            titleTemplate: `%s | ${this.$t('pages.marketAnalysis.head.titleTemplate')}`,
            title: this.$t('pages.marketAnalysis.head.title'),
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: this.$t('pages.marketAnalysis.head.description'),
                },
                {
                    hid: 'og:title',
                    name: 'og:title',
                    content: this.$t('pages.marketAnalysis.head.ogTitle'),
                },
                {
                    hid: 'og:description',
                    name: 'og:description',
                    content: this.$t('pages.marketAnalysis.head.ogDescription'),
                },
                {
                    hid: 'twitter:title',
                    name: 'twitter:title',
                    content: this.$t('pages.marketAnalysis.head.twitterTitle'),
                },
                {
                    hid: 'twitter:description',
                    name: 'twitter:description',
                    content: this.$t('pages.marketAnalysis.head.twitterDescription'),
                }
            ],
        }
    },

    computed: {
        isLoggedIn() {
            return !!this.$store.state.account.user
        },
        isSubscribedFinAgent() {
            return this.isLoggedIn && this.$store.state.account.subscribedProductIds?.includes(subscribeProductKeys.finAgent);
        },
        showPersonalizedTab() {
            return this.isSubscribedFinAgent;
        },
        homeIconPath() {
            return this.$vuetify.theme.dark ?
                require('@/assets/icons/home-dark.svg') :
                require('@/assets/icons/home-light.svg');
        },
    },

    watch: {
        pageKey: {
            immediate: true,
            handler(pageKey) {
                this.activeTab = pageKey;
            }
        },
        isLoggedIn: {
            handler(value) {
                if (!value) {
                    return
                }
                this.$nextTick(() => this.activeTab = this.pageKey);
            },
            immediate: true
        },
    },

    created() {
        this.tabConstants = tabConstants;
        this.sectorTabConstants = sectorTabConstants;
    },
}
